import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Stack, TextField, PrimaryButton } from "@fluentui/react";
import { createPromptCategory } from "../../../api/admin/api_admin";
import { AdminLabel, ErrorDialog, LinkButton } from "../components";

export const AddPromptTemplateCategory = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [categoryName, setCategoryName] = useState<string>("");

    const handleSubmit = async () => {
        if (!categoryName.trim()) {
            setError("カテゴリ名を入力してください");
            return;
        }

        setSubmitting(true);
        setError(null);

        try {
            const result = await createPromptCategory({ name: categoryName });

            if (result.success) {
                navigate("/menu/prompt_templates_list");
            } else {
                setError(result.message || "登録に失敗しました");
            }
        } catch (err) {
            setError("登録中にエラーが発生しました");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Stack tokens={{ childrenGap: 20 }}>
            <AdminLabel text="プロンプトテンプレートカテゴリ追加" />

            {
                <ErrorDialog 
                    content={error ?? ""} 
                    onDismiss={() => setError(null)} 
                    isOpen={Boolean(error)} />
            }

            <Stack tokens={{ childrenGap: 15 }} styles={{ root: { maxWidth: 600 } }}>
                <TextField
                    name="name"
                    label="カテゴリ名"
                    value={categoryName}
                    onChange={(_, newValue) => setCategoryName(newValue || "")}
                    required
                    autoComplete="off"
                />

                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <PrimaryButton
                        text="追加"
                        onClick={handleSubmit}
                        disabled={submitting || !categoryName.trim()}
                    />
                    <LinkButton link_to="/menu/prompt_templates_list" text="戻る" />
                </Stack>
            </Stack>
        </Stack>
    );
};
